import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { API_URLS } from '../constants/api-urls.constants';
import { Observable, retry } from 'rxjs';
import { Router } from '@angular/router';


@Injectable({ 
    providedIn: 'root' 
})

export class AuthTokenService {
  private readonly INACTIVITY_LIMIT = 15 * 60 * 1000;
  private lastActivity = Date.now();
  private readonly CHECK_INTERVAL = 60 * 1000;
  private watchdog?: number;
  private ddmoRefreshTimer: any;
  private isRefreshing: boolean = false;

  constructor(private http: HttpClient,private router: Router) {
    this.trackActivity();
  }

  startSession() {
    if (this.watchdog) return;
    this.watchdog = window.setInterval(() => {
      const inactiveFor = Date.now() - this.lastActivity;
 
      if (inactiveFor >= this.INACTIVITY_LIMIT) {
        this.logout();
        return;
      }
      if (this.isRefreshExceeds()) {
        if (this.isRefreshing) return;
        if (!this.refreshToken) {
          this.checkDdmoTokenExpiry();
          return;
        }
        this.isRefreshing = true;
        this.refreshAccessToken()
        .pipe(
          retry({ count: 1, delay: 1000 }) // retry once after 1 sec
        )
        .subscribe({
          next: token => {
            this.saveTokens(token)
            this.isRefreshing = false;
          },
          error: () => {
            this.isRefreshing = false;
            if (!this.isAuthenticated()) {
              this.logout()
            }
          }
        });
        return;
      }
      this.checkDdmoTokenExpiry();
    }, this.CHECK_INTERVAL);
  }
 
  saveTokens(token: any) {
    localStorage.setItem('auth0_access_token', token.access_token);
    localStorage.setItem('auth0_id_token', token.id_token);
    localStorage.setItem('refresh_token', token.refresh_token);
    localStorage.setItem('lastRefreshTime',Date.now().toString());  // for refreshing token in all 15 min
  }
 
  get accessToken(): string | null {
    return localStorage.getItem('accessToken');
  }
 
  get refreshToken(): string | null {
    return localStorage.getItem('refresh_token');
  }
 
  isTokenExpired(): boolean {
    const expiresAt = Number(localStorage.getItem('expires_at'));
    return Date.now() > expiresAt - 60_000; // refresh 1 min early
  }

    isRefreshExceeds(): boolean {
    const lastRefresh = Number(localStorage.getItem('lastRefreshTime'));
    if (!lastRefresh) return true;
    const elapsed = Date.now() - lastRefresh;
    return elapsed >= 14 * 60 * 1000;
  }
 
  refreshAccessToken() {
    let logintype = localStorage.getItem('logintype')
    return this.http.post<any>(
      `${environment.authTokenApi}${API_URLS.AUTH_TOKEN}`,
      {
        grant_type: 'refresh_token',
        client_id: logintype == 'admin'?environment.auth0Config.clientIdInternal:environment.auth0Config.clientIdExternal,
        refresh_token: this.refreshToken
      }
    );
  }
 
  logout() {
    this.logoutUserAuditlog()
    let logintype = localStorage.getItem('logintype')
    localStorage.setItem("isLoggedIn", "false");
    let returnUrl = environment.redirectUrlAfterRegister
    const loggedUserDetails = localStorage.getItem("loggedUserDetails")
    const loggedUserData = loggedUserDetails?JSON.parse(loggedUserDetails):null;
    const userRole = loggedUserData?.roles[0]?.roleName;
    if(userRole?.toLowerCase() == 'dentist south carolina'){
      returnUrl = environment.redirectUrlSC;
    }
    let clientId = logintype == 'admin'?environment.auth0Config.clientIdInternal:environment.auth0Config.clientIdExternal;
    let logOutUrl = `${environment.logOutUrl}?client_id=${clientId}&returnTo=${returnUrl}`
    localStorage.clear();
    sessionStorage.clear()
    localStorage.setItem("logout", "true");
    window.location.assign(logOutUrl);
  }
 
  private trackActivity() {
    ['mousemove', 'keydown', 'scroll', 'touchstart'].forEach(e =>
      window.addEventListener(e, () => this.lastActivity = Date.now())
    );
 
    setInterval(() => {
      if (Date.now() - this.lastActivity > this.INACTIVITY_LIMIT) {
        this.logout();
      }
    }, 60_000);
  }

  isAuthenticated(): boolean {
  const token = this.accessToken;
  const expiry =localStorage.getItem('ddmoTokenExpiry');
  const expiresAt = expiry ? new Date(expiry).getTime() : 0;
  return !!token && !!expiresAt && Date.now() < expiresAt;
}
 
checkDdmoTokenExpiry() {
  const expiry = localStorage.getItem('ddmoTokenExpiry');
  
  const auth0Token = localStorage.getItem('auth0_id_token');
  if (!expiry || !auth0Token) return;
 
  const expiryTime = new Date(expiry).getTime();
  const bufferTime = 2 * 60 * 1000;
 
  const timeLeft = expiryTime - Date.now();
 
  if (timeLeft <= bufferTime) {
    this.callDdmoToken(auth0Token).subscribe({
      next: token => {
      let ddmoToken = token.ddmo?.accessToken
      localStorage.setItem('accessToken', ddmoToken)
      localStorage.setItem('ddmoTokenExpiry', token.ddmo?.expiresOn);
      },
      error: () => this.logout()
    });
  }
}

callDdmoToken(authToken: any): Observable<any> {
    const headers = new HttpHeaders({
        'Authorization': 'Bearer ' + authToken,
        'Content-Type': 'application/json'
      });
    return this.http.get(`${environment.userApiUrl}${API_URLS.TOKEN_URL}`, { headers })
  }

  initializeAuthState() {
    const auth0Token = localStorage.getItem('auth0_id_token');
    const ddmoToken = localStorage.getItem('accessToken');
   
    if (!auth0Token || !ddmoToken) {
      return;
    }
  
    if (!localStorage.getItem('lastRefreshTime')) {
      localStorage.setItem('lastRefreshTime', Date.now().toString());
    }
   
    this.startSession();
  }
logoutUserAuditlog(){
  let auditLog:any={};
  auditLog["websiteCodeId"] = 50;
  auditLog["trailType"]='Trail';
  auditLog["trailWebSessionId"]=localStorage.getItem("trailWebSessionId")?.toUpperCase();
  auditLog["absolutePath"]=this.router.url.split('?')[0];
  const impersonatedUser = localStorage.getItem("impersonatedUser") ?? ""
    if(impersonatedUser){
      let adminUserId = parseInt(localStorage.getItem("loginUserId")!);
      let impersonatedUserId = parseInt(localStorage.getItem("impersonatedUserId")!);
      auditLog["userId"] = adminUserId ? adminUserId : 0
      auditLog["impersonateId"]= impersonatedUserId?impersonatedUserId:0;
    }else{
      let userId = parseInt(localStorage.getItem("loggedUserId")!);
      auditLog["userId"] = userId ? userId : 0
      auditLog["impersonateId"]=0;
    }
  auditLog["notes"]= "Logout"
  this.logWebTraillog(auditLog).subscribe(data=>{
  });
}
logWebTraillog(payload: any): Observable<any> {
  const url = `${environment.userAuditUrl}${API_URLS.WEB_TRAIL_LOG}`;
  return this.http.post(url, payload);
}

}
 